<meta name="description" content="تقوم شركة كودس روتس علي حجز افضل السيرفرات واستضافة المواقع ">
<meta name="keywords" content=" استضافة مواقع ,حجز سيرفرات,حجز دومين">
<meta name="description" content="شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفريق تسويق خبرة في مجال التسويق الاكتروني واشهار المواقع والسيو ومسك الكلمات وعمل خطط تسويقيه كامله">
<meta name="keywords" content="تسويق الكتروني-حملات جوجل اد ورد-جوجل سيو">

<section class="hosting-page">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 text-center">
                <h1 class="section-title">
                    مميزات الاستضافه من Codesroots
                </h1>
                <h3>
                    تتميز استضافة لدينا بامان و استقرار غير مسبوق معد خصيصا لراحة بالك قد تصل الى 99% على اتصال و لدينا العديد من خطط الاستضافة التي تناسب العديد و المواقع و العمل الخاص باسعار معقولة تناسب كافة الطلبات .        
                </h3>
            </div>
            <div class="col-12">
                <app-fatc-boxes [facts]='facts'></app-fatc-boxes>
            </div>
            <div class="col-12" style="margin-top: 40px; background-color: #50D0C7; padding-bottom: 40px; padding-top: 40px;">
                <h3 class="packages-title text-center">
                    اختر الخطة المناسبة لك
                </h3>
                <app-packages [packages]='packages'></app-packages>
            </div>
            <div class="col-12" style="margin-top: 40px">
                <h3 class="inner-title text-center">
                    ملاحظات مهمة
                </h3>
                <ul class="list-unstyled text-right">
                    <li data-sr="enter bottom, move 200px  over 2s">ندعم معظم البرمجيات المشهورة، مثال Wordpress, vBulletin, Open Cart, و الكثير .</li>
                    <li data-sr="enter bottom, move 200px  over 2s">جميع خدمات الاستضافة مقدمة بالتعاون مع أقوى مراكز البيانات في العالم .</li>
                    <li data-sr="enter bottom, move 200px  over 2s">تفعيل فورى للطلب و استلام لمعلومات الاستضافة خلال دقائق معدودة .</li>
                    <li data-sr="enter bottom, move 200px  over 2s">جميع خطط الاستضافة تتمتع بنسب موارد عالية ( Ram &amp; CPU ) .</li>
                    <li data-sr="enter bottom, move 200px  over 2s">لوحة تحكم عربية لإدارة الاستضافة و حساب الإستهلاك .</li>
                </ul>                
            </div>            
        </div>
    </div>
</section>